import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { TYPES } from 'modules/billing/lib/types'

export interface ISubscriptionAddon {
  // eslint-disable-next-line
  [key: string]: any
}

class SubscriptionAddon extends Model<ISubscriptionAddon> {
  constructor(attr: ISubscriptionAddon = {}) {
    super(attr)
    makeObservable(this, {
      type: computed,
      isApp: computed,
    })
  }

  static urlRoot() {
    return '/billing/subscription_addons'
  }

  get type(): string {
    return this.attributes.type
  }

  get isApp(): boolean {
    return this.type === TYPES.app || this.type === TYPES.app_integration
  }
}

export default SubscriptionAddon
